import { TeamStatsProvider } from "../../hooks/useTeamStats";
import { MatchHeader } from "./MatchHeader";
import { Scores } from "../scores/Scores";
import { MatchFiltersProvider } from "../../hooks/useMatchFilters";
import { MatchFilters } from "./MatchFilters";
import {
  ActiveMatchProvider,
  useActiveMatch,
} from "../../hooks/useActiveMatch";
import { ScheduledMatch } from "../../types";
import { Games } from "../stats/Games";
import { Records } from "../stats/Records";
import { Accordion, AccordionItem } from "@heroui/react";
import { CoolHeading } from "../CoolHeading";
import { ReactComponent as ChevronLeft } from "../../assets/img/chevron-left.svg";
import { useHomeTeam } from "../../hooks/useHomeTeam";
import { MachineProfiles } from "../stats/MachineProfiles";

type Props = {
  initialMatch: ScheduledMatch;
};

export function MatchDisplay({ initialMatch }: Props) {
  return (
    <ActiveMatchProvider initialMatch={initialMatch}>
      <InnerActiveMatch />
    </ActiveMatchProvider>
  );
}

function InnerActiveMatch() {
  const { match } = useActiveMatch();

  return (
    <>
      <MatchHeader
        venueId={match.venueId}
        setVenueId={undefined} // venue select disabled for now
      />
      <MatchFiltersProvider>
        <TeamStatsProvider>
          <div className="flex w-full max-w-[1200px] flex-col gap-4">
            <MatchFilters />
            <Accordion
              variant="shadow"
              showDivider={false}
              selectionMode="multiple"
              className="bg-gray-200 py-2 dark:bg-gray-800"
              itemClasses={{
                heading: "py-2",
                trigger: "inline-block max-w-full w-full py-0",
                indicator: "float-right mr-4 -mt-[2.41rem]",
                titleWrapper:
                  "flex flex-1 items-center p-4 bg-gray-300/60 dark:bg-gray-700 rounded-xl",
                content: "flex flex-col gap-2 items-center justify-center",
              }}
              defaultExpandedKeys={["Records"]}
            >
              {[
                { title: "Scores", component: <Scores /> },
                { title: "Records", component: <Records /> },
                { title: "Games", component: <Games /> },
              ].map(({ title, component }) => (
                <AccordionItem
                  key={title}
                  textValue={title}
                  title={
                    <CoolHeading
                      variant="subtle"
                      className="text-2xl uppercase"
                    >
                      {title}
                    </CoolHeading>
                  }
                  indicator={
                    <ChevronLeft className={`text-primary dark:text-white`} />
                  }
                >
                  {component}
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </TeamStatsProvider>
      </MatchFiltersProvider>
    </>
  );
}
